// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import { backToTopStyles } from "@synd/App/Components/Common/BackToTop";
import { clientWidth, PAGE_LAYOUT_SPACING } from "@synd/XDL/constants";
import { color, layoutContainer, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

backToTopStyles.backToTopBtn = {
    css: css`
        position: sticky;
        ${layoutContainer}
        justify-content: flex-end;
        z-index: ${getProp("theme.zIndex.backToTop")};
        bottom: 8px;
        width: fit-content;
        &&& {
            margin-right: 0;
        }
        &:hover {
            ${IconWrapper}, svg {
                color: ${color("common.ui9")};
            }
        }
        margin-top: 33px;
        ${({ visible }: any) => css`
            display:"flex";
            visibility: ${visible ? "visible" : "hidden"};
            right: calc(calc(${clientWidth} - var(${PAGE_LAYOUT_SPACING.xl})) / 2);
            ${xScreen("lte", "lg")} {
                right: calc(calc(${clientWidth} - var(${PAGE_LAYOUT_SPACING.lg})) / 2);
            }
        `}
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};
